import { DEFAULT_FEE } from "@/app/lib/order-helpers";
import { AssetType, OrderPosition, TradePosition, useTransactionFeeQuery } from "@/app/types/generated/graphql";
import { AggregatedRegistryCode } from "@/app/types/okta.types";

export const useTransactionFee = ({ registryCode }: { registryCode?: AggregatedRegistryCode }) => {
  const { data, loading, error } = useTransactionFeeQuery({
    // skip fee query for ANY_REGISTRY_CODE
    skip: !registryCode,
    variables: {
      input: {
        assetType: AssetType.Rec,
        registryCode,
      },
    },
  });

  const getAppliedFee = (orderPosition: OrderPosition | TradePosition) => {
    const fee =
      orderPosition == OrderPosition.Ask
        ? data?.transactionFee.sellerTxnFeePercent
        : data?.transactionFee.buyerTxnFeePercent;

    return fee ?? DEFAULT_FEE;
  };

  if (error) {
    throw error;
  }

  return {
    getAppliedFee,
    loading,
  };
};
